import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

export const MinusIcon = (props: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const AthletaSVG = (
    <svg viewBox="0 0 13 2" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 0v2H0V0z" />
    </svg>
  );

  const BananaRepublicSVG = (
    <svg fill="none" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h12v2H0V0z" fill="#000" />
    </svg>
  );

  const GapSVG = (
    <svg fill="none" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h12v2H0V0z" fill="#000" />
    </svg>
  );

  const OldNavySVG = (
    <svg viewBox="0 0 10.5 2.25" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.75 0h-9A.75.75 0 000 .75v.75a.75.75 0 00.75.75h9a.75.75 0 00.75-.75V.75A.75.75 0 009.75 0z"
        fill={theme.color.b1}
      />
    </svg>
  );

  const CrossBrandSVG = (
    <svg fill="none" viewBox="0 0 12 2" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h12v2H0V0z" fill="#000" />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: AthletaSVG,
    [Brands.BananaRepublic]: BananaRepublicSVG,
    [Brands.BananaRepublicFactoryStore]: BananaRepublicSVG,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: OldNavySVG,
    crossBrand: CrossBrandSVG,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
